var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageBgUpgradePlan = function SvgImageBgUpgradePlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 310,
    height: 102,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#image-bg-upgrade-plan_svg__a)",
    stroke: "#F0C0B0",
    d: "M212.691-54.887C121.802-75.664 15.757-44.362-25.905-26.114 88.64 126.27 315.955 379.576 308.852 173.731c-7.102-205.844-67.067-238.18-96.161-228.618Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "image-bg-upgrade-plan_svg__a",
    x1: 210.593,
    x2: 102.407,
    y1: -64.626,
    y2: 182.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DFD8"
  })))));
};
export default SvgImageBgUpgradePlan;